// extracted by mini-css-extract-plugin
export default {"filter":"NewsPage_filter__2yMpq","newsList":"NewsPage_newsList__drwGV"};